import axios from 'axios';

export function getWorkspaceActivityLog(wId) {
  return (dispatch) => {
    // return axios.get(`/bot/api/workspace/${wId}/workspaceActivityLog`).then((res) => res);
    return axios
      .get(`/bot/api/w/${wId}/workspace/workspaceActivityLog`)
      .then((res) => res);
  };
}

export function getWorkspaceCkecInActivies(wId) {
  return (dispatch) => {
    // return axios.get(`/api/workspace/${wId}/workspaceCheckInActivities`).then((res) => res);
    return axios
      .get(`/api/w/${wId}/workspaceCheckInActivities`)
      .then((res) => res);
  };
}

export function getWorkspaceJiraNotificationsLog(wId) {
  return (dispatch) => {
    // return axios.get(`/bot/api/workspace/${wId}/workspaceJiraNotificationsLog`).then((res) => res);
    return axios
      .get(`/bot/api/w/${wId}/workspace/workspaceJiraNotificationsLog`)
      .then((res) => res);
  };
}

export function getWorkspaceActiveUsers(wId) {
  return (dispatch) => {
    // return axios.get(`/bot/api/workspace/${wId}/workspaceActiveUsers`).then((res) => res);
    return axios
      .get(`/bot/api/w/${wId}/workspace/workspaceActiveUsers`)
      .then((res) => res);
  };
}

export function updateGridMetrics(wId, id) {
  // return axios.get(`/bot/api/enterprise/${id}/updateGridMetrics`).then((res) => res.data);
  return axios
    .get(`/bot/api/w/${wId}/enterprise/${id}/updateGridMetrics`)
    .then((res) => res.data);
}

export function getGridMetrics(wId, id) {
  // return axios.get(`/api/enterprise/${id}/getGridMetrics`).then((res) => res.data);
  return axios
    .get(`/api/w/${wId}/enterprise/${id}/getGridMetrics`)
    .then((res) => res.data);
}

export function getGridLevelUsermapping(wId, id) {
  // return axios.get(`/bot/api/enterprise/${id}/getGridLevelUsermapping`).then((res) => res.data);
  return axios
    .get(`/bot/api/w/${wId}/enterprise/${id}/getGridLevelUsermapping`)
    .then((res) => res.data);
}

export function getGridDateWiseActivities(wId, id) {
  // return axios.get(`/bot/api/enterprise/${id}/getGridDateWiseActivities`).then((res) => res.data);
  return axios
    .get(`/bot/api/w/${wId}/enterprise/${id}/getGridDateWiseActivities`)
    .then((res) => res.data);
  // /bot/api/w/:wId/enterprise/:enterpriseId/getGridDateWiseActivities
}

export const getWorkspaceDashboardChartData = (wId, enterpriseId) => {
  // return axios.get(`/bot/api/${wId}/getWorkspaceDashboardChartData`).then((res) => res.data);
  let url = `/bot/api/w/${wId}/workspace/getWorkspaceDashboardChartData`;
  if (enterpriseId) url += `?enterpriseId=${enterpriseId}`;
  return axios.get(url).then((res) => res.data);
};

// axios.get(`/bot/api/enterpriseId/E01F37K78BX/gridWorkspacesActivityLog`)
// axios.get(`/bot/api/enterpriseId/E01F37K78BX/gridWorkspaceJiraNotificationsLog`)
// axios.get(`/bot/api/enterpriseId/E01F37K78BX/gridWorkspaceActiveUsers`)
// axios.get(`/bot/api/enterpriseId/E01F37K78BX/gridWorkspaceCheckInActivities`)
